/* Menu mobile 2026 — snippets/nav-mobile-2026.liquid
   - cale la carte sur la barre mobile à chaque ouverture (la barre bouge :
     barre d'annonce, header sticky, 769–989px pleine largeur) ;
   - onglets (1er niveau) et accordéons (2e niveau, un seul ouvert) ;
   - Échap, et fermeture avant d'ouvrir la recherche ou le panier.
   L'ouverture elle-même reste à theme.js (body.js-drawer-open-left). */
(function () {
  var drawer = document.querySelector('[data-navm26]');
  if (!drawer) return;

  var body = document.body;
  var closeBtn = drawer.querySelector('.mobile-menu--close-btn');
  var burger = document.querySelector('.js-drawer-open-left-link');

  function isOpen() {
    return body.classList.contains('js-drawer-open-left') && !document.querySelector('collection-filtering-form.is-open');
  }

  function close() {
    if (closeBtn) closeBtn.click();
  }

  function placeOnBar() {
    var bar = document.querySelector('.mobile-nav-bar-wrapper');
    if (!bar) return;
    var rect = bar.getBoundingClientRect();
    if (!rect.height) return;
    drawer.style.setProperty('--navm26-top', Math.max(rect.top, 0) + 'px');
    drawer.style.setProperty('--navm26-left', rect.left + 'px');
    drawer.style.setProperty('--navm26-right', document.documentElement.clientWidth - rect.right + 'px');
    drawer.style.setProperty('--navm26-bar-h', rect.height + 'px');
  }

  // ── Ouverture / fermeture (classe posée par theme.js) ───────────────────
  var wasOpen = false;
  function sync() {
    var open = isOpen();
    if (open === wasOpen) return;
    wasOpen = open;
    if (burger) burger.setAttribute('aria-expanded', String(open));
    if (open) {
      drawer.scrollTop = 0;
      drawer.focus({ preventScroll: true });
    } else if (burger && drawer.contains(document.activeElement)) {
      burger.focus({ preventScroll: true });
    }
  }

  // Mesure AVANT que theme.js pose la classe (capture), pour que la carte
  // parte de la bonne position dès la première image de l'animation.
  if (burger) burger.addEventListener('click', placeOnBar, true);
  new MutationObserver(sync).observe(body, { attributes: true, attributeFilter: ['class'] });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });

  // Loupe / panier : on referme le menu ; theme.js ouvre ensuite le tiroir.
  drawer.querySelectorAll('[data-navm26-dismiss]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  // ── Onglets ─────────────────────────────────────────────────────────────
  var tabs = Array.prototype.slice.call(drawer.querySelectorAll('.navm26__tab[role="tab"]'));

  function selectTab(tab) {
    tabs.forEach(function (t) {
      var selected = t === tab;
      t.setAttribute('aria-selected', String(selected));
      t.tabIndex = selected ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
  }

  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () {
      selectTab(tab);
    });
    tab.addEventListener('keydown', function (e) {
      var step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (!step) return;
      e.preventDefault();
      var next = tabs[(i + step + tabs.length) % tabs.length];
      selectTab(next);
      next.focus();
    });
  });

  // ── Accordéons (un seul ouvert par panneau) ─────────────────────────────
  drawer.querySelectorAll('button.navm26__pill').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var group = toggle.closest('.navm26__group');
      var open = !group.classList.contains('is-open');
      group.parentElement.querySelectorAll('.navm26__group.is-open').forEach(function (other) {
        if (other === group) return;
        other.classList.remove('is-open');
        other.querySelector('.navm26__pill').setAttribute('aria-expanded', 'false');
      });
      group.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    });
  });
})();
